import { render, staticRenderFns } from "./LanguageSwitcherModal.vue?vue&type=template&id=70a9561e&scoped=true"
import script from "./LanguageSwitcherModal.vue?vue&type=script&lang=js"
export * from "./LanguageSwitcherModal.vue?vue&type=script&lang=js"
import style0 from "./LanguageSwitcherModal.vue?vue&type=style&index=0&id=70a9561e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70a9561e",
  null
  
)

export default component.exports